import styled from "styled-components";
import { theme } from "uikit";

const Label = styled.div`
	font-family: "Lato";
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 21px;

	color: ${theme.colors.primary};
`;

export default Label;
